import { CALC_SERVICES, fmt } from '../components/CostCalculatorWidget';

const API = process.env.REACT_APP_BACKEND_URL;
const SERVICE_KEYS = CALC_SERVICES.map((s) => s.key);

const tools = [
  {
    name: 'estimate_cost',
    description: 'Estimate the installed price range (USD) for an EpoxyArt33 floor coating project in Naples / Southwest Florida. Services: garage (flake epoxy garage floor), metallic (metallic epoxy), pool (pool deck or lanai), commercial (commercial floors).',
    inputSchema: {
      type: 'object',
      properties: {
        service: { type: 'string', enum: SERVICE_KEYS, description: 'Type of floor to coat' },
        sqft: { type: 'number', minimum: 50, maximum: 100000, description: 'Approximate area in square feet' },
      },
      required: ['service', 'sqft'],
    },
    annotations: { readOnlyHint: true },
    execute: async ({ service, sqft }) => {
      const s = CALC_SERVICES.find((x) => x.key === service);
      const area = Number(sqft);
      if (!s || !(area > 0)) return { error: 'Unknown service or invalid sqft' };
      return {
        service: s.label, sqft: area, low_usd: Math.round(area * s.low), high_usd: Math.round(area * s.high),
        range: `${fmt(area * s.low)} – ${fmt(area * s.high)}`, per_sqft: `$${s.low}–$${s.high}`,
        note: 'Typical 2026 installed price in Naples, FL. Concrete repair, moisture mitigation and coating removal quoted separately. Exact quote free within 24 hours.',
        quote_url: 'https://epoxyart33.com/contact', calculator_url: 'https://epoxyart33.com/cost-calculator',
      };
    },
  },
  {
    name: 'request_quote',
    description: 'Request a free epoxy / concrete coating quote from EpoxyArt33 (Naples, FL). Creates a lead; a human estimator replies within 24 hours by phone or email.',
    inputSchema: {
      type: 'object',
      properties: {
        name: { type: 'string', description: 'Full name' },
        phone: { type: 'string', description: 'Phone number' },
        email: { type: 'string', format: 'email', description: 'Email address' },
        service: { type: 'string', description: 'Service of interest, e.g. garage floor coating, pool deck, metallic epoxy, commercial' },
        message: { type: 'string', description: 'Project details: location, size, timeline' },
        zip_code: { type: 'string', description: 'ZIP code of the project (optional)' },
      },
      required: ['name', 'phone', 'email', 'service'],
    },
    annotations: { readOnlyHint: false },
    execute: async (input) => {
      const res = await fetch(`${API}/api/quotes`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: input.name, phone: input.phone, email: input.email, service: input.service, zip_code: input.zip_code || null, message: input.message || 'Quote requested via AI agent (WebMCP).', source_page: '/webmcp', website: '' }),
      });
      if (!res.ok) return { ok: false, error: 'Could not submit the quote right now. Call (239) 276-1462.' };
      const data = await res.json();
      return { ok: true, quote_id: data.id, message: 'Quote request received. EpoxyArt33 will contact you within 24 hours.', phone: '(239) 276-1462' };
    },
  },
];

export const registerWebMCPTools = () => {
  if (typeof window === 'undefined') return;
  const mc = (typeof document !== 'undefined' && document.modelContext) || window.navigator?.modelContext;
  if (!mc || typeof mc.registerTool !== 'function' || window.__ea33WebMCP) return;
  window.__ea33WebMCP = true;
  tools.forEach((tool) => {
    try { mc.registerTool(tool); } catch { /* duplicate or unsupported — ignore */ }
  });
};
